import { FinancialDocumentPdfTemplateType, SimpleInvoice, useRepositoryMutation } from '@mews-commander/data-access';
import { CommanderFormProps, useHandledDialogFormControls } from '@mews-commander/form';
import { createZodFormResolver } from '@mews/framework';
import { Stack } from '@optimus-web/core';
import { SendReminderFormValues, sendReminderSchema, sendReminderFormDefaultValues } from '../schema';
import { LinkedInvoices } from '../fields/LinkedInvoicesField';
import { SendReminderFormContent } from './SendReminderFormContent';

interface SendReminderDialogContentProps {
    accountId: string;
    invoices: SimpleInvoice[];
    ownerEmails: string[];
    allowedInvoiceTemplateTypes: FinancialDocumentPdfTemplateType[];
    onFormSuccess?: () => void;
}

export const SendReminderDialogContent = ({
    accountId,
    invoices,
    allowedInvoiceTemplateTypes,
    onFormSuccess,
    ownerEmails,
    ...props
}: CommanderFormProps & SendReminderDialogContentProps) => {
    const { mutateAsync } = useRepositoryMutation('invoices', 'sendReminderEmails', {
        invalidateQueries: {
            invoices: ['getAll'],
        },
    });

    const onSubmit = async (formData: SendReminderFormValues) => {
        await Promise.all(
            invoices.map(
                async (invoice) =>
                    await mutateAsync({
                        ...formData,
                        invoiceId: invoice.invoiceId,
                    })
            )
        );
    };

    const { renderFormContent } = useHandledDialogFormControls<SendReminderFormValues>({
        ...props,
        resolver: createZodFormResolver(sendReminderSchema),
        onSubmit,
        defaultValues: sendReminderFormDefaultValues,
        onSuccess: () => onFormSuccess?.(),
    });

    return renderFormContent(
        <Stack spacing="100" vertical>
            <LinkedInvoices invoices={invoices} />
            <SendReminderFormContent allowedInvoiceTemplateTypes={allowedInvoiceTemplateTypes} emails={ownerEmails} />
        </Stack>
    );
};
